import { Routes } from '@angular/router';

import { AuthService } from '../auth/auth.service';

import { InsightNewComponent } from './insight-new.component';

export const InsightRoutes: Routes = [
    {
        path: 'insight',
        component: InsightNewComponent,
        canActivate: [AuthService],
    },
];
